'use strict';

module.exports.LABEL_CATEGORY_ALL = '_all';

module.exports.SHOP_SEARCH_CATEGORIES = [
  { label: 'All Figures & Dolls', value: 'figures-dolls' },
  { label: 'Scale Figures', value: 'figures-dolls_scale-figures' },
  { label: 'Bishoujo Figures', value: 'figures-dolls_bishoujo-figures' },
  { label: 'Nendoroid & Mini Figures', value: 'figures-dolls_chibi-figures' },
  { label: 'Action Figures', value: 'figures-dolls_action-figures' },
  { label: 'Books', value: 'books' },
  { label: 'Toys & Collectibles', value: 'toys-knick-knacks' },
  { label: 'Apparel & Cosplay', value: 'otaku-apparel-cosplay' },
  { label: 'Plushies', value: 'plushies' },
  { label: 'CD & DVD/Blu-ray', value: 'cd-dvd-blu-ray' }
];
